import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';

import * as _ from 'underscore';

// Service
import { LivestocktypeListService } from '../../service/livestocktype-list/livestocktype-list.service';

@Component({
	selector: 'app-livestocktype-list',
	templateUrl: './livestocktype-list.component.html',
	providers: [
		LivestocktypeListService,
		HttpModule
	]
})
export class LivestocktypeListComponent implements OnInit {

	private token;
	public lives: any[] = [];
	public resultCount: number = 0;
	public orderby: string = "Tipo";
	public sort: string = "asc";
	public permissoes: any[] = [];
	currentPage: number = 0;
	livestockType: FormGroup;

	constructor(fb: FormBuilder, private livestocktypeListService: LivestocktypeListService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.livestockType = fb.group({
			'Tipo': '',
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.searchLive(this.livestockType.value, 0, false);
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc"; 
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.searchLive(this.livestockType.value, this.currentPage, false);
	}

	searchLive(value: any, page, isSearch) {
		if (isSearch) {
			this.orderby = "Tipo";
			this.sort = "asc";
			this.currentPage = 0;
		}
		this.livestocktypeListService.searchLive(this.token, value.Tipo, value.Ativo, this.orderby, this.sort, page).subscribe(result => {
			if (result.Success) {
				this.lives = result.Result;
				this.resultCount = result.Count;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		})
	}

	paginar($event: any) {
		this.currentPage = $event;
		this.searchLive(this.livestockType.value, $event, false);
	}

}



// WEBPACK FOOTER //
// ./src/app/livestocktype/component/livestocktype-list/livestocktype-list.component.ts